export default ({request}) => ({
  ecomWarehouseListApi(data = {}) {
    return request({
      url: '/ecom/warehouse/list',
      method: 'post',
      data,
    })
  },
  ecomWarehouseDetailApi(data = {}) {
    return request({
      url: '/ecom/warehouse/detail',
      method: 'post',
      data,
    })
  },
  ecomWarehouseSaveApi(data = {}) {
    return request({
      url: '/ecom/warehouse/save',
      method: 'post',
      data,
    })
  },
  ecomWarehouseDelApi(data = {}) {
    return request({
      url: '/ecom/warehouse/del',
      method: 'post',
      data,
    })
  },
})
